<template>
<v-card-actions>
  <slot name="actions">
    <v-btn @click="$emit('close')" text>{{ close_text }}</v-btn>
    <slot name="center_actions">
      <v-spacer></v-spacer>
    </slot>
    <v-btn color="success" @click="$emit('submit')">{{ submit_text }}</v-btn>
  </slot>
</v-card-actions>
</template>

<script>
export default {
name: "CardActions",
  props:{
    submit_text: {
      default: 'submit'
    },
    close_text: {
      default: 'close'
    }
  }
}
</script>

<style scoped>

</style>
